module.exports = __webpack_public_path__ + "img/rectangle-1223_optimized-compressed.df007690.jpg";